import React from "react";

export default function Win10Modal({
  open,
  onClose,
  onConfirm,
  title = "Information",
  message = "This is an information message.",
  type = "info", // info | warning | error
}) {
  if (!open) return null;

  const iconColors = {
    info: "bg-blue-600",
    warning: "bg-yellow-500",
    error: "bg-red-600",
  };

  const iconSymbols = {
    info: "i",
    warning: "!",
    error: "×",
  };

  return (
    <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
      {/* Modal box */}
      <div className="w-[420px] bg-white shadow-xl border border-gray-300 rounded-sm">
        {/* Title bar */}
        <div className="bg-[#0078D7] text-white px-3 py-2 flex justify-between items-center select-none">
          <span className="font-semibold">{title}</span>
          <button
            onClick={onClose}
            className="text-white hover:bg-blue-500 px-2 rounded-sm"
          >
            ×
          </button>
        </div>

        {/* Content */}
        <div className="flex p-4 space-x-4">
          {/* Icon */}
          <div
            className={`w-12 h-12 flex items-center justify-center text-white text-xl font-bold rounded-full ${iconColors[type]}`}
          >
            {iconSymbols[type]}
          </div>

          {/* Text */}
          <div>
            <h3 className="text-lg font-semibold mb-1">{title}</h3>
            <p className="text-gray-700">{message}</p>
          </div>
        </div>

        {/* Buttons */}
        <div className="border-t px-4 py-3 flex justify-end space-x-2 bg-gray-50">
          <button
            onClick={onClose}
            className="px-4 py-1 border border-gray-400 bg-white hover:bg-gray-100"
          >
            Cancel
          </button>

          <button
            onClick={onConfirm}
            className="px-4 py-1 border border-blue-700 bg-[#0078D7] text-white hover:bg-blue-600"
          >
            OK
          </button>
        </div>
      </div>
    </div>
  );
}
